import React from 'react';
import { Popover, PopoverTrigger, PopoverContent } from './ui/popover';
import { Bold, Italic, Palette } from 'lucide-react';

// Farbpalette für Zeilen-/Tag-Markierungen
const PALETTE = ['#ef4444', '#f59e0b', '#eab308', '#10b981', '#3b82f6', '#8b5cf6', '#ec4899', '#64748b'];

function RowStyleMenu({ bold = false, italic = false, color = null, showFormat = true, onChange, align = 'end' }) {
  const set = (patch) => onChange({ bold, italic, color, ...patch });

  return (
    <Popover>
      <PopoverTrigger asChild>
        <button
          type="button"
          className="no-print text-slate-400 hover:text-slate-700 p-1 rounded flex items-center justify-center shrink-0"
          title="Stil / Farbe"
          data-testid="row-style-button"
        >
          {color ? (
            <span
              style={{ display: 'inline-block', width: 13, height: 13, borderRadius: 9999, background: color, border: '1px solid #cbd5e1' }}
            />
          ) : (
            <Palette className="h-4 w-4" />
          )}
        </button>
      </PopoverTrigger>
      <PopoverContent className="w-auto p-2" align={align}>
        {showFormat && (
          <div className="flex gap-1 mb-2">
            <button
              type="button"
              onClick={() => set({ bold: !bold })}
              className={`px-2 py-1 rounded border ${bold ? 'bg-slate-800 text-white border-slate-800' : 'bg-white text-slate-700 border-slate-300'}`}
              title="Fett"
            >
              <Bold className="h-4 w-4" />
            </button>
            <button
              type="button"
              onClick={() => set({ italic: !italic })}
              className={`px-2 py-1 rounded border ${italic ? 'bg-slate-800 text-white border-slate-800' : 'bg-white text-slate-700 border-slate-300'}`}
              title="Kursiv"
            >
              <Italic className="h-4 w-4" />
            </button>
          </div>
        )}
        <div className="flex gap-1.5 items-center flex-wrap" style={{ maxWidth: 168 }}>
          {PALETTE.map((c) => (
            <button
              key={c}
              type="button"
              onClick={() => set({ color: c })}
              title={c}
              style={{
                width: 20,
                height: 20,
                borderRadius: 9999,
                background: c,
                border: color === c ? '2px solid #0f172a' : '1px solid #cbd5e1',
              }}
            />
          ))}
          <button
            type="button"
            onClick={() => set({ color: null })}
            title="keine Farbe"
            className="text-xs px-2 py-0.5 rounded border border-slate-300 bg-white text-slate-600"
          >
            keine
          </button>
        </div>
      </PopoverContent>
    </Popover>
  );
}

export default RowStyleMenu;
